import { render, staticRenderFns } from "./ApprovalAuthorityInfo.vue?vue&type=template&id=b158d42e&scoped=true&"
import script from "./ApprovalAuthorityInfo.vue?vue&type=script&lang=js&"
export * from "./ApprovalAuthorityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalAuthorityInfo.vue?vue&type=style&index=0&id=b158d42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b158d42e",
  null
  
)

export default component.exports